import axios from "axios";
// import qs from "qs";

export const mentorSignUp = async(body) => {
  return await axios.post(`mentor/signup`, body);
}
